module.exports = __webpack_public_path__ + "img/r.7d52e271.png";